/**
 * Extracts the filename from a given URL string.
 * @param {string} url - The URL string from which to extract the filename.
 * @returns {string} The filename extracted from the URL.
 */
function extractFilenameFromUrl(url?: string | null): string {
  const defaultFilename = '';

  if (!url) return defaultFilename;

  try {
    const pathname = new URL(url).pathname;
    const filename = pathname.split('/').pop();
    return filename ? decodeURIComponent(filename) : defaultFilename;
  } catch {
    // Fallback to manual parsing
    const fallback = url.split('/').pop()?.split('?').shift();
    return fallback ? decodeURIComponent(fallback) : defaultFilename;
  }
}

export default extractFilenameFromUrl;
